import axios from 'axios' //引用安装好的axios
import router from '../../src/router/router.js'
import {
	Notification,
	MessageBox,
	Message,
	Loading
} from 'element-ui'
import {
	getAesKey,
	aesDecrypt,
	aesEncrypt,
	DecryptNode,
	EncryptNode
} from './secret.js'
let baseURL = ''

if (process.env.NODE_ENV === "development") {
	baseURL = 'charge'
	
} else {
	baseURL = 'https://www.am-mes.cn/charge/'
	// baseURL = 'http://101.37.20.134/charge/'
	// baseURL = 'http://8.155.51.41:8001/charge/'
	
}

export const upLoadimg = baseURL+"/projectAdvertisement/addProjectAdvertisement"

let num = 0
const service = axios.create({
	baseURL: baseURL, // url = base url + request url
	withCredentials: true, // send cookies when cross-domain requests
	// timeout: 5000, // request timeout
	crossDomain: true
})
//params 用于get请求 拼接在url后面
//data 用于post请求放在请求体里面
export default function ajax(url = '', params = {}, medthod = {}, responseType,str,type) {
	// 1. 定义promise对象
	
	if (localStorage.getItem('serviceProviderId')) {
		if(params){
			params.serviceProviderId = localStorage.getItem('serviceProviderId')
		}
	}
	let errData=JSON.parse(JSON.stringify(params))
	// console.log(params)
	let promise;
	return new Promise((resolve, reject) => {

		if(responseType =="form" ){
			
		}else{
			var dataStr = JSON.stringify(params)
			var key = getAesKey(16);
			var enParm = aesEncrypt(dataStr, key)
			var encodStr = EncryptNode(key)
			params = {
				data: enParm,
				secretKey: encodStr
			}
		}

		let config = {
			headers: {
				// 'content-type': 'application/x-www-form-urlencoded'	
			}
		}
		// 判断请求类型
		if (responseType=='blob') {
			config.responseType = "blob"
		}
		if (responseType=='form') {
			config.headers =  {
				'content-type': 'application/x-www-form-urlencoded'	
			}
		}
		if(responseType=='docking'){
			config.headers =  {
				'Authorization':'Bearer ' + "84efb058-43fb-4f46-b771-83aeda8cd23f"	
			}
		}
		if (localStorage.getItem('token')) {
			config.headers.token = localStorage.getItem('token')
		}else{
			config.headers.token = ""
		}
		if (medthod == 'post') {
			promise = service.post(url, params, config)
		}
		if (medthod == 'get') {
			let paramsStr = '';
			Object.keys(params).forEach(key => {
				paramsStr += key + '=' + params[key] + '&'
			});
			if (paramsStr !== '') {
				paramsStr = paramsStr.substr(0, paramsStr.lastIndexOf('&'))
			}

			url += '?' + paramsStr;
			promise = service.get(url, config)
		}

		promise.then((response) => {
			var responKey
			var responValue 
			var data
			var a
			if(response.data.data){
				responKey = DecryptNode(response.data.secretKey)
				data = response.data.data.replace(/[\r\n]/g, "")
				responValue = aesDecrypt(data, responKey)
				// console.log(responValue,'hghghg')
				// a = DecryptNode(responValue.Data)
				// console.log(a,'bfbfbf')
			}else{
				 responValue = response.data
			}
			if (responseType) {
				if(str){
					if(type){
						let url = window.URL.createObjectURL(new Blob([responValue], {
							type: "."+type
						}));
						let a = document.createElement('a');
						a.style.display = 'none';
						a.href = url;
						a.setAttribute('download', str+"."+type);
						document.body.appendChild(a);
						a.click();
						url = window.URL.revokeObjectURL(url);
						document.body.removeChild(a);
						resolve({returnCode:200})
					}else{
						let url = window.URL.createObjectURL(new Blob([responValue], {
							type: ".xlsx"
						}));
						let a = document.createElement('a');
						a.style.display = 'none';
						a.href = url;
						a.setAttribute('download', str+".xlsx");
						document.body.appendChild(a);
						a.click();
						url = window.URL.revokeObjectURL(url);
						document.body.removeChild(a);
					}
					
				}
				
			} else {
				if (responValue.returnCode != 200) {
					if (responValue.returnCode == -1) {
						num++
						if(num==1){
							MessageBox.confirm('', '用户登录失效，请重新登录！', {
								confirmButtonText: '确定',
								type: 'warning',
								showCancelButton: false,
								closeOnClickModal: false,
								closeOnPressEscape: false,
								showClose: false,
								center: true
							}).then(() => {
								router.push('/login');
								num=0
							});
						}
						
					} else {
						Message({
							type: 'warning',
							message: responValue.returnMessage || "服务异常!"
						});
					}

				}
			}

			resolve(responValue)
		}).catch(error => {
			console.log("异常接口" + url, "参数", errData)
			Message({
				type: 'warning',
				message: '服务异常!'
			});
			reject(error)
		})
	})
}